import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import {
  ErrorPanel,
  FullScreenOverlay,
  LoadingIndicator,
} from '@nbirl/nbi-common-ui-libs';
import { Location } from 'history';

import { ForgotPassword, Login, ValidateEmail } from './modules/auth';
import { ProtectedRoute } from './shared/components';
import { APP_ROUTES, PATHS } from './shared/constants';
import { CurrentUserProvider, useAuth } from './shared/context';
import { AuthState } from './shared/enum';
import { AuthenticatedLayout, UnauthenticatedLayout } from './shared/layout';

export const Routes = () => {
  const auth = useAuth();
  const location = useLocation<{ from?: Location } | undefined>();

  if (auth.state === AuthState.Loading) {
    return (
      <FullScreenOverlay>
        <LoadingIndicator />
      </FullScreenOverlay>
    );
  }

  if (auth.state === AuthState.Error) {
    return (
      <FullScreenOverlay>
        <ErrorPanel error={auth.error} />
      </FullScreenOverlay>
    );
  }

  if (auth.state === AuthState.SignedIn) {
    return (
      <CurrentUserProvider>
        <AuthenticatedLayout>
          <Switch>
            {Object.values(APP_ROUTES).map(({ Component, ...props }) => (
              <ProtectedRoute {...props} key={props.routeKey}>
                <Component />
              </ProtectedRoute>
            ))}
            <Redirect to={location.state?.from ?? PATHS.DocumentsHome} />
          </Switch>
        </AuthenticatedLayout>
      </CurrentUserProvider>
    );
  }

  if (auth.state === AuthState.VerifyEmail) {
    return (
      <UnauthenticatedLayout>
        <Switch>
          <Route path={PATHS.ValidateEmail}>
            <ValidateEmail />
          </Route>
          <Redirect
            to={{
              pathname: PATHS.ValidateEmail,
              state: {
                from: location,
              },
            }}
          />
        </Switch>
      </UnauthenticatedLayout>
    );
  }

  return (
    <UnauthenticatedLayout>
      <Switch>
        <Route path={PATHS.LogIn}>
          <Login />
        </Route>
        <Route path={PATHS.ForgotPassword}>
          <ForgotPassword />
        </Route>
        <Redirect
          to={{
            pathname: PATHS.LogIn,
            state: {
              from:
                auth.state === AuthState.SignIn && auth.initial
                  ? location
                  : undefined,
            },
          }}
        />
      </Switch>
    </UnauthenticatedLayout>
  );
};
